/* eslint-disable max-len */
import React, {useState, useEffect} from 'react';
import './styles.css';
import axios from 'axios';
import ProfileCard from './ProfileCard';
import NavBar from './Navbar';
import TokenManager from './TokenManager';
import ProgressBar from '@ramonak/react-progress-bar';

/* eslint "require-jsdoc": [2, {
    "require": {
        "FunctionDeclaration": true,
        "MethodDefinition": false,
        "ClassDeclaration": false
    }
}]*/
/**
* @return {html} Profile Page.
  */
function Profile() {
  const memberId = TokenManager.getId();

  const [data, setData] = useState([]);
  const [currentPoints, setcurrentPoints] = useState([]);
  const [nextPoints, setnextPoints] = useState([]);
  const [nextTier, setnextTier] = useState([]);


  useEffect(() => {
    getVouchers();
    axios.get(` https://blooming-springs-86289.herokuapp.com/api/login/info/${memberId}`)
        .then((response) => {
          setcurrentPoints(response.data[0]);
          localStorage.setItem('tier', response.data[0].tier);
        }); // get current score


    axios.get(`https://blooming-springs-86289.herokuapp.com/api/member/nexttier`) // get next tier
        .then((response) => {
          useNextPoints();
          useNextTier();
        });
  }, []);

  const getVouchers = () => {
    axios.get(`https://blooming-springs-86289.herokuapp.com/api/member/vouchers/${memberId}`)
        .then((response) => {
        // console.log(response)
          setData(response.data);
        });
  };
  const currentTier = localStorage.getItem('tier');

  const useNextPoints = () => {
    switch (currentTier) {
      case 'Bronze':
        setnextPoints(100);
        break;
      case 'Silver':
        setnextPoints(500);
        break;
      case 'Gold':
        setnextPoints(1000);
        break;
      case 'Platinum':
        setnextPoints(2000);
        break;
      case 'Diamond':
        setnextPoints('Max');
        break;
      default:
        return null;
    }
  };

  const useNextTier = () => {
    switch (currentTier) {
      case 'Bronze':
        setnextTier('Silver');
        break;
      case 'Silver':
        setnextTier('Gold');
        break;
      case 'Gold':
        setnextTier('Platinum');
        break;
      case 'Platinum':
        setnextTier('Diamond');
        break;
      case 'Diamond':
        setnextTier('Nil');
        break;
      default:
        return null;
    }
  };

  return (
    <>
      <NavBar />
      <br />
      <div>
        <div className="container2">
          <div className="tiers">
            <br />

            <div className='leftside'>{currentTier}</div>
            <div className='rightside'>{nextTier}</div>
            <ProgressBar className="wrapper" completed={currentPoints.accumulated_points / nextPoints * 100} maxCompleted={100} />
            <br />
            <div className='leftside'>{currentPoints.accumulated_points} points</div>


            <div className='rightside' >{nextPoints - currentPoints.accumulated_points}  points </div>

            <div className='rightside'> More to achieve {nextTier}</div>
          </div>
        </div>
        <div className='myvoucher'>My Vouchers</div>
        {data.map((item, index) => {
          return (
            <ProfileCard
              amount={item.amount}
              promocode={item.promo_code}
              voucherId={item.voucher_id}
              key={index}
              updateVouchers={() => getVouchers()}
            />
          );
        })}
      </div>

    </>
  );
};

export default Profile;
